export const Spacer = {
  render(h) {
    return h('div', { style: { flex: '1' } });
  },
};
export const HStack = {
  props: ['pstyle'],
  render(h) {
    return h(
      'div',
      { style: { display: 'flex', flexDirection: 'row', ...this.pstyle } },
      this.$slots.default
    );
  },
};

export const VStack = {
  props: ['pstyle'],
  render(h) {
    return h(
      'div',
      {
        style: {
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          ...this.pstyle,
        },
      },
      this.$slots.default
    );
  },
};

export const Flex = {
  props: ['fstyle'],
  render(h) {
    return h(
      'div',
      {
        style: {
          display: 'flex',
          ...this.fstyle,
        },
      },
      this.$slots.default
    );
  },
};
